// Created by: Imran Khan July 2026
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/DateRangePicker/styles/index.css";

export default function DashboardFilterBar({
  financialYears,
  salesExecutives,
  selectedFY,
  selectedExecutive,
  dateRange,
  onFYChange,
  onExecutiveChange,
  onDateRangeChange,
  onRefresh,
  lastUpdated,
}) {
  return (
    <div className="fy-filter-bar">
      <Row className="align-items-end g-3">
        <Col lg={8}>
          <div>
            <h2 className="fy-dashboard-title mb-0">Financial Year Dashboard</h2>
            <p className="fy-dashboard-subtitle mb-0">Complete Business Overview</p>
          </div>
        </Col>
        <Col lg={4} className="text-lg-end">
          <button type="button" className="btn btn-outline-primary btn-sm fy-refresh-btn" onClick={onRefresh}>
            <i className="fa-solid fa-rotate me-1" /> Refresh
          </button>
          {lastUpdated && (
            <small className="text-muted d-block mt-1">
              Last Updated: {new Date(lastUpdated).toLocaleString("en-IN")}
            </small>
          )}
        </Col>
      </Row>

      <Row className="g-3 mt-2">
        <Col md={4} lg={3}>
          <Form.Label className="fy-filter-label">Financial Year</Form.Label>
          <Form.Select value={selectedFY} onChange={(e) => onFYChange(e.target.value)}>
            {financialYears.map((fy) => (
              <option key={fy.value} value={fy.value}>
                {fy.label}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col md={4} lg={3}>
          <Form.Label className="fy-filter-label">Sales Executive</Form.Label>
          <Form.Select value={selectedExecutive} onChange={(e) => onExecutiveChange(e.target.value)}>
            <option value="">All</option>
            {salesExecutives.map((user) => (
              <option key={user.id} value={user.id}>
                {user.label}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col md={4} lg={6}>
          <Form.Label className="fy-filter-label">Date Range</Form.Label>
          <DateRangePicker
            value={dateRange}
            onChange={onDateRangeChange}
            character=" – "
            format="dd MMM yyyy"
            block
          />
        </Col>
      </Row>
    </div>
  );
}
